import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Flex,
  Text,
  Stack,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { createPromo } from "../../../../../store/gifts/promoSlice";

const CreatePromoModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const promo = useSelector((s) => s.promo);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <Modal isOpen onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <form
          onSubmit={handleSubmit(async (values) => {
            await dispatch(createPromo(values)).unwrap();
            onClose();
          })}
        >
          <ModalHeader>Create Promo</ModalHeader>
          <ModalBody>
            {promo.error && (
              <Alert status="error" mb={4}>
                <AlertIcon />
                {promo.error}
              </Alert>
            )}
            <Stack spacing={4}>
              <FormControl>
                <FormLabel>Code</FormLabel>
                <Input {...register("code", { required: "required" })} />
                {errors.code && (
                  <Text color="red.500" mt={1}>
                    {errors.code.message}
                  </Text>
                )}
              </FormControl>
              <FormControl>
                <FormLabel>Expiration Date</FormLabel>
                <Input
                  type="date"
                  min={new Date().toISOString().split('T')[0]}
                  {...register("expirationDate", { required: "required" })}
                />
                {errors.expirationDate && (
                  <Text color="red.500" mt={1}>
                    {errors.expirationDate.message}
                  </Text>
                )}
              </FormControl>
              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Input
                  type="number"
                  step="1"
                  {...register("amount", {
                    required: "required",
                    valueAsNumber: true,
                  })}
                />
              </FormControl>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Flex gap={3}>
              <Button
                type="submit"
                colorScheme="green"
                isLoading={promo.isLoading}
              >
                Save
              </Button>
              <Button onClick={onClose}>Close</Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};
export default CreatePromoModal;
